import { Colors, Services } from '@sigma-frontend-libs/commons'
import { CONTACTLIST_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { breakpoints, buttonModes, components, icons, labelModes, sizes, states } from '@/utils'

import button from '@/components/button'
import buttonFavorite from '@/components/button/favorite'
import buttonRefresh from '@/components/button/refresh'
import fileManager from '@/components/file/manager'
import info from '@/components/info'
import HeadTitle from '@/components/misc/HeadTitle'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import contactsDialogs from '@/components/services/contacts/dialogs'
import contactsFilter from '@/components/services/contacts/filter'
import contactsItem from '@/components/services/contacts/item'
import eventsHistoryButton from '@/components/services/eventsHistory/button'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import owner from '@/components/templates/service/item/owner'
import textOverflow from '@/components/text/overflow'

function renderDivider(h, trigger) {
  if (trigger) {
    return h(components.divider)
  }

  return h('div')
}

function renderPagination(h, trigger) {
  if (trigger) {
    return h(
      'div',
      {
        class: `${Services.contacts}-pagination`
      },
      [
        h(
          pagination,
          {
            props: {
              value: this.restData[Services.contacts].find.pagination,
              service: Services.contacts
            },
            on: {
              input: event => {
                this.restData[Services.contacts].find.pagination = event
              }
            }
          }
        ),
        h(
          buttonRefresh,
          {
            props: {
              state: this.restData[Services.contacts].find.state,
              shortClickMethod: () => {
                return this.rest[Services.contacts].find()
              },
              longClickMethod: () => {
                return this.rest[Services.contacts].find({}, { noCache: true })
              }
            }
          }
        )
      ]
    )
  }
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: `preloader__holder ${Services.contacts}-preloader`
    },
    [ h(preloader) ]
  )
}

function renderSearchGeneratorItemTitle(h, item) {
  return h(
    textOverflow,
    {
      props: {
        value: item.title
      }
    }
  )
}
function renderSearchGeneratorItemType(h, item) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.contactLists}.types.${item.type}`),
        size: sizes.tiny,
        color: Colors.grey
      }
    }
  )
}
function renderSearchGeneratorItem(h, item) {
  return h(
    'router-link',
    {
      class: {
        'search-generator__item': true,
        'search-generator__item--active': item.id === this.$route.params.id
      },
      props: {
        to: {
          name: `${Services.contacts}.single`,
          params: { id: item.id }
        }
      },
      key: item.id
    },
    [
      h(
        'div',
        {
          class: 'search-generator__item-content'
        },
        [
          renderSearchGeneratorItemTitle.call(this, h, item),
          renderSearchGeneratorItemType.call(this, h, item)
        ]
      )
    ]
  )
}
function renderSearchGenerator(h) {
  return h(
    'search-generator',
    {
      scopedSlots: {
        create: () => {
          return h(
            components['list-item'],
            {
              props: {
                color: Colors.secondary,
                label: this.getTranslate(`${Services.contactLists}.buttons.create`),
                dense: true
              },
              on: {
                click: () => {
                  this.dialogType = `${Services.contactLists}.create`
                  this.showDialog = true
                }
              }
            }
          )
        },
        filter: ({ filter }) => {
          return h(
            components.select,
            {
              props: {
                value: filter.type,
                label: this.getTranslate(`${Services.contactLists}.labels.type`),
                items: CONTACTLIST_TYPES.map(type => {
                  return {
                    title: this.getTranslate(`${Services.contactLists}.types.${type}`),
                    value: type
                  }
                }),
                clearable: true,
                labelMode: labelModes.hidden,
                dense: true,
                details: false
              },
              on: {
                input: event => {
                  filter.type = event
                }
              }
            }
          )
        },
        default: ({ item }) => {
          return renderSearchGeneratorItem.call(this, h, item)
        }
      }
    }
  )
}

function renderEditButton(h, id) {
  return h(
    button,
    {
      props: {
        icon: icons.edit,
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.contactListId = id
          this.dialogType = `${Services.contactLists}.update`
          this.showDialog = true
        }
      }
    }
  )
}
function renderFavoriteButton(h, id) {
  return h(
    buttonFavorite,
    {
      props: {
        id,
        service: Services.contactLists
      }
    }
  )
}
function renderTitle(h, { title, type }) {
  return h(
    sticker,
    {
      props: {
        value: title,
        label: this.getTranslate(`${Services.contactLists}.types.${type}`),
        maxWidth: 200,
        width: 'auto',
        copy: true
      }
    }
  )
}
function renderOwner(h, item) {
  return h(
    owner,
    {
      props: {
        value: item
      }
    }
  )
}
function renderInfo(h) {
  const { id } = this.restData[Services.contactLists].get.data

  return h(
    'div',
    {
      class: `${Services.contacts}-info`
    },
    [
      renderEditButton.call(this, h, id),
      renderFavoriteButton.call(this, h, id),
      renderTitle.call(this, h, this.restData[Services.contactLists].get.data),
      renderOwner.call(this, h, this.restData[Services.contactLists].get.data)
    ]
  )
}

function renderEventsHistoryButton(h) {
  if (this.canGetContactsAsAdmin) {
    let label = false
    if (this.viewport.breakpoint.xl) {
      label = true
    }

    return h(
      eventsHistoryButton,
      {
        props: {
          label,
          entityId: this.$route.params.id,
          rounded: true
        }
      }
    )
  }
}
function renderRemoveContactListButton(h) {
  let label
  if (this.viewport.breakpoint.xl) {
    label = this.getTranslate(`${Services.contactLists}.buttons.remove`)
  }

  return h(
    button,
    {
      props: {
        label,
        icon: icons.delete,
        color: Colors.error,
        mode: buttonModes.flat
      },
      directives: [
        {
          name: 'g-tooltip',
          options: { value: this.isActive || this.getTranslate(`${Services.contactLists}.tooltips.remove`) }
        }
      ],
      on: {
        click: () => {
          this.contactListId = this.restData[Services.contactLists].get.data.id
          this.dialogType = `${Services.contactLists}.remove`
          this.showDialog = true
        }
      }
    }
  )
}
function renderAddContactButton(h) {
  let label
  if (this.viewport.breakpoint.xl) {
    label = this.getTranslate(`${Services.contacts}.buttons.add`)
  }

  return h(
    button,
    {
      props: {
        label,
        icon: icons.exposure_plus_1,
        color: Colors.primary,
        mode: buttonModes.flat
      },
      directives: [
        {
          name: 'g-tooltip',
          options: { value: this.isActive || this.getTranslate(`${Services.contacts}.tooltips.add`) }
        }
      ],
      on: {
        click: () => {
          this.contactListId = this.restData[Services.contactLists].get.data.id
          this.dialogType = `${Services.contacts}.create`
          this.showDialog = true
        }
      }
    }
  )
}
function renderImportContactsButton(h) {
  let label
  if (this.viewport.breakpoint.xl) {
    label = this.getTranslate('misc.buttons.import')
  }

  return h(
    button,
    {
      props: {
        label,
        icon: icons.cloud_upload,
        mode: buttonModes.flat
      },
      directives: [
        {
          name: 'g-tooltip',
          options: { value: this.isActive || this.getTranslate(`${Services.contactLists}.tooltips.import`) }
        }
      ],
      on: {
        click: () => {
          this.showFileManager = true
        }
      }
    }
  )
}
function renderFilterButton(h) {
  let label
  if (this.viewport.breakpoint.xl) {
    label = this.getTranslate('misc.buttons.filter')
  }

  return h(
    button,
    {
      props: {
        label,
        icon: icons.filter_list,
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.showFilter = !this.showFilter
        }
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: `${Services.contacts}-actions`
    },
    [
      renderEventsHistoryButton.call(this, h),
      renderRemoveContactListButton.call(this, h),
      renderAddContactButton.call(this, h),
      renderImportContactsButton.call(this, h),
      renderFilterButton.call(this, h)
    ]
  )
}
function renderHeader(h) {
  if (this.restData[Services.contactLists].get.state === states.ready) {
    return h(
      'div',
      {
        class: `${Services.contacts}-header`
      },
      [
        renderInfo.call(this, h),
        renderActions.call(this, h)
      ]
    )
  }
}
function renderFilter(h) {
  if (this.showFilter) {
    return h(
      contactsFilter,
      {
        props: {
          value: this.restData[Services.contacts].find.filter
        },
        on: {
          input: event => {
            this.restData[Services.contacts].find.filter = event
          }
        }
      }
    )
  }
}
function renderItems(h) {
  const contactsEvents = [ `${Services.contacts}.update`, `${Services.contacts}.remove` ]
  const on = contactsEvents.reduce((result, event) => {
    result[event] = id => {
      this.contactId = id
      this.dialogType = event
      this.showDialog = true
    }

    return result
  }, {})

  return h(
    'div',
    {
      class: `${Services.contacts}-items`
    },
    [
      this.restData[Services.contacts].find.data.map(item => {
        return h(
          contactsItem,
          {
            props: { value: item },
            on
          }
        )
      })
    ]
  )
}
function renderContactsList(h) {
  if (this.restData[Services.contacts].find.pagination.total > 0) {
    return renderItems.call(this, h)
  } else {
    switch (this.restData[Services.contacts].find.state) {
      case states.loading: {
        return renderPreloader.call(this, h)
      }
      case states.ready:
      default: {
        return h(components.empty)
      }
    }
  }
}
function renderContactsContent(h) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      }
    },
    [
      renderPagination.call(this, h, true),
      renderDivider.call(this, h, this.restData[Services.contacts].find.pagination.total),
      renderContactsList.call(this, h),
      renderDivider.call(this, h, this.restData[Services.contacts].find.pagination.total),
      renderPagination.call(this, h, !!this.restData[Services.contacts].find.pagination.total)
    ]
  )
}
function renderContent(h) {
  if (this.$route.params.id) {
    return h(
      'div',
      {
        class: `${Services.contacts}-content`
      },
      [
        renderHeader.call(this, h),
        renderFilter.call(this, h),
        renderContactsContent.call(this, h)
      ]
    )
  }

  if (this.viewport.size.width > breakpoints.md) {
    return h(
      'div',
      {
        class: `${Services.contacts}__empty`
      },
      [ h(components.empty) ]
    )
  }
}

function renderContactsDialogs(h) {
  return h(
    contactsDialogs,
    {
      props: {
        id: this.contactId || this.contactListId,
        type: this.dialogType,
        show: this.showDialog,
        ListId: this.restData[Services.contactLists].get.data && this.restData[Services.contactLists].get.data.id
      },
      on: {
        show: event => {
          if (event === false) {
            this.contactId = undefined
            this.contactListId = undefined
            this.dialogType = undefined
          }
          this.showDialog = event
        }
      }
    }
  )
}
function renderImportDialogHeader(h) {
  return h(
    HeadTitle,
    {
      props: { value: this.getTranslate(`${Services.contacts}.dialogs.titles.import`) },
      slot: 'header'
    }
  )
}
function renderImportDialogBody(h) {
  switch (this.importContactsResult.state) {
    case states.loading: {
      return h(
        'div',
        {
          class: `${Services.contacts}-import-dialog__content`
        },
        [
          renderPreloader.call(this, h),

          h(
            'div',
            {
              domProps: { innerHTML: this.getTranslate(`${Services.contacts}.contents.import.${states.loading}`) }
            }
          )
        ]
      )
    }
    case states.success: {
      return h(
        info,
        {
          style: {
            width: '100%'
          },
          props: {
            icon: icons.done,
            color: Colors.success,
            value: this.getTranslate(`${Services.contacts}.contents.import.${states.success}`, { count: this.importContactsResult.total })
          }
        }
      )
    }
    case states.error: {
      return h(
        info,
        {
          props: {
            icon: icons.warning,
            color: Colors.warning,
            value: this.getTranslate(`${Services.contacts}.contents.import.${states.error}`)
          }
        }
      )
    }
  }
}
function renderImportDialogFooter(h) {
  switch (this.importContactsResult.state) {
    case states.success:
    case states.error: {
      return h(
        'div',
        {
          class: `${Services.contacts}-import-dialog__footer`,
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.close'),
                mode: buttonModes.flat
              },
              on: {
                click: () => {
                  this.showImportContacts = false
                  this.importContactsResult.state = undefined
                  this.importContactsResult.total = 0
                }
              }
            }
          )
        ]
      )
    }
  }
}
function renderImportDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        rounded: true,
        value: this.showImportContacts,
        closeOnClick: false,
        closeOnEsc: false,
        maxWidth: 500
      },
      on: {
        input: event => {
          this.showImportContacts = event
        }
      }
    },
    [
      renderImportDialogHeader.call(this, h),
      h(
        'div',
        {
          class: `${Services.contacts}-import-dialog__body`
        },
        [ renderImportDialogBody.call(this, h) ]
      ),

      renderImportDialogFooter.call(this, h)
    ]
  )
}

function renderFileManager(h) {
  return h(
    fileManager,
    {
      props: {
        show: this.showFileManager,
        flat: true,
        readonly: true,
        embedded: true,
        types: [ 'csv', 'xls', 'xlsx' ]
      },
      on: {
        show: event => {
          this.showFileManager = event
        },
        input: event => {
          this.showFileManager = false
          this.showImportContacts = true
          this.importContacts(event.id)
        }
      }
    }
  )
}

export default function(h) {
  const classNames = {
    [Services.contacts]: true,
    [`${Services.contacts}--empty`]: !this.$route.params.id
  }

  return h(
    'div',
    {
      class: classNames
    },
    [
      renderSearchGenerator.call(this, h),
      renderContent.call(this, h),
      renderContactsDialogs.call(this, h),
      renderImportDialog.call(this, h),
      renderFileManager.call(this, h)
    ]
  )
}
